export default __webpack_public_path__ + "static/media/download-svg.507fb709.svg";